import ApiService from '../services/apiService';

// Server-side onboarding session (micro-back). The uuid is the public handle
// that survives Transbank's redirect in another browser/window.
export const createOnboardingRegistrationRequest = ({ dispatch, params, failureCallback, successCallback }) =>
  ApiService.request('post', '/onboarding/registrations', {
    dispatch,
    params,
    failureCallback,
    successCallback
  });

export const updateOnboardingRegistrationRequest = (uuid, { dispatch, params, failureCallback, successCallback }) =>
  ApiService.request('patch', `/onboarding/registrations/${uuid}`, {
    dispatch,
    params,
    failureCallback,
    successCallback
  });

export const showOnboardingRegistrationRequest = (uuid, { dispatch, failureCallback, successCallback }) =>
  ApiService.request('get', `/onboarding/registrations/${uuid}`, {
    dispatch,
    failureCallback,
    successCallback
  });

export const finalizeOnboardingRegistrationRequest = (uuid, { dispatch, failureCallback, successCallback }) =>
  ApiService.request('post', `/onboarding/registrations/${uuid}/finalize`, {
    dispatch,
    failureCallback,
    successCallback
  });
